import React from 'react';
import Translate from 'react-translate-component';
import { path, pathOr, find } from 'ramda';

export const getApprover = (request, userId) => {
    const lastRoute = find(item => (
        path(['approver', 'id'], item) === userId
    ), pathOr([], ['approvalHistory'], request)) || {};

    return {
        ...lastRoute,
        ...pathOr({}, ['approver'], lastRoute),
    };
}

export const renderCellItem = option => (
    <span>
        {option.name} - <Translate
            content={`metro.request.position${option.is_vacant ? 'Vacant' : 'Placed'}`}
        /> {option.worker_name && (
            <span>({option.worker_name})</span>
        )}
    </span>
);
